import React from "react";
import { NewPassengerCard } from "./NewPassengerCard";
import { PassengerCard } from "./PassengerCard";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";

interface Props {
  flightId: number
  isPrivateJet: boolean
  isCreating: boolean
  setIsCreating: (isCreating: boolean) => void
  isInSidePanel: boolean
  passengers: server.dto.FlightPassenger[]
  refetchPassengers: () => Promise<void>
  isInPageEditable: boolean
}

export const Passengers = (props: Props) => {
  const onPassengerSaved = async () => {
    await props.refetchPassengers();
    props.setIsCreating(false);
  }

  return <div className="passengers-list">
    {(props.passengers.length === 0 && !props.isCreating) && <NoDataAvailableDiv />}
    {props.passengers.map(p => <PassengerCard
      isInPageEditable={props.isInPageEditable}
      key={p.flightPassengerId}
      isInSidePanel={props.isInSidePanel}
      isPrivateJet={props.isPrivateJet}
      passenger={p}
      onDeleted={props.refetchPassengers}
    />)}
    {props.isCreating && <NewPassengerCard
      inSidePanel={props.isInSidePanel}
      isPrivateJet={props.isPrivateJet}
      flightId={props.flightId}
      onSaved={onPassengerSaved}
      onCancel={() => props.setIsCreating(false)}
    />}
  </div>
}